import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'success-popup',
  templateUrl: './success-popup.component.html',
  styleUrls: ['./success-popup.component.scss']
})
export class SuccessPopupComponent implements OnInit {
  hide = true;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {msg: string, btnText, Create_msg, btnClose, type},
    private route: ActivatedRoute,
    private router: Router,
    private dialogRef:MatDialogRef<SuccessPopupComponent>
    ) { }

  ngOnInit(): void {
    this.data.btnText = this.data.btnText ?? "Done"
  }


  closePopup(){
    this.dialogRef.close();
  }



  donePopup(data="done"){
    this.dialogRef.close(data);
  }


}
